/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IrrJobTypeEnum = 'deploy' | 'delete' | 'upgrade' | 'relocate';

export const IrrJobTypeEnum = {

    DEPLOY: 'deploy' as IrrJobTypeEnum,

    DELETE: 'delete' as IrrJobTypeEnum,

    UPGRADE: 'upgrade' as IrrJobTypeEnum,

    RELOCATE: 'relocate' as IrrJobTypeEnum
};

